import { UiConfiguration } from 'core/services'

export class Configuration {
	uiConfiguration!: UiConfiguration
}
